import React, { useState, useEffect } from "react";
import {
  Card,
  Popconfirm,
  Drawer,
  Button,
  Modal,
  TimePicker,
  Switch,
  notification,
  Space,
} from "antd";
import moment from "moment";
import _ from "lodash";
import { connect } from "react-redux";

// Style
import {
  CloseOutlined,
  CheckOutlined,
  PlusOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

//Actions
import {
  getScheduleTimingList,
  getScheduleTimingListReset,
} from "../../action/getScheduleTimeListAction";
import {
  saveScheduleTimingCustomize,
  saveScheduleTimingCustomizeReset,
} from "../../action/saveScheduleTimingCustomizeAction";
import { dateFormat, timeSlotFormat } from "../../utils";
import {
  SlotView,
  SlotViewDelete,
  SlotViewAdd,
  XButton,
} from "./ScheduleTimingCustomizeStyle";

const ScheduleTimingCustomize = (props) => {
  //Variables
  const {
    saveScheduleTimingCustomize,
    saveScheduleTimingCustomizeState,
    saveScheduleTimingCustomizeReset,
    getScheduleTimingList,
    getScheduleTimingListState,
    getScheduleTimingListReset,
    setIsDateAvailable,
    dateCellRender,
    selectedDate,
  } = props;

  const [drawerData, setDrawerData] = useState({
    time_slots: [],
    availability: true,
    date: "",
    schedule_timing_id: "",
    mode: "",
  });
  const [addSlot, setAddSlot] = useState({});
  const initialTime = {
    start_time: null,
    end_time: null,
  };
  const [value, setValue] = useState(initialTime);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isHolidayModalVisible, setIsHolidayModalVisible] = useState(false);
  const [confirmSwitchAction, setConfirmSwitchAction] = useState("");
  
  //Callback

  useEffect(() => {
    if (props.visible === false) {
      getScheduleTimingListReset();
    }
  }, [props.visible]);

  useEffect(() => {
    if (props.parameters && props.visible) {
      getScheduleTimingList(props.parameters);
    }
  }, [props.parameters, props.visible]);

  useEffect(() => {
    if (getScheduleTimingListState.apiState === "success") {
      if (getScheduleTimingListState.list?.schedule_timing_slot.length > 0) {
        //when there are basic Slots
        // let availability =
        //   getScheduleTimingListState.list.schedule_timing_slot[0]
        //     .availability !== undefined;
        setDrawerData({
          ...drawerData,
          ["_id"]: getScheduleTimingListState.list?.schedule_timing_slot[0]._id,
          ["date"]: props.parameters.date,
          ["schedule_timing_id"]:
            getScheduleTimingListState.list.schedule_timing_slot[0]
              .schedule_timing_id,
          ["time_slots"]:
            getScheduleTimingListState.list.schedule_timing_slot[0].time_slots,
          ["availability"]:
          getScheduleTimingListState.list.schedule_timing_slot[0]?.availability !== undefined? getScheduleTimingListState.list.schedule_timing_slot[0]?.availability:true,
          ["mode"]: getScheduleTimingListState.list.schedule_timing_slot[0]
            .availability
            ? "put"
            : "post",
        });
        setIsDateAvailable(
          getScheduleTimingListState.list.schedule_timing_slot[0]?.availability !== undefined? getScheduleTimingListState.list.schedule_timing_slot[0]?.availability:true
        );
        // setIsDateAvailable(
        //   getScheduleTimingListState.list.schedule_timing_slot[0].availability
        // );
      } else if (getScheduleTimingListState.list) {
        setDrawerData({
          ...drawerData,
          ["date"]: props.parameters.date,
          ["schedule_timing_id"]: getScheduleTimingListState.list._id,
          ["time_slots"]: [],
          ["availability"]: false,
          ["mode"]: "post",
        });
        setIsDateAvailable(false);
      }
    }
    if (getScheduleTimingListState.apiState === "error") {
      notification["error"]({
        message: getScheduleTimingListState.message,
        placement: "topRight",
      });
    }
  }, [getScheduleTimingListState]);

  useEffect(() => {
    if (saveScheduleTimingCustomizeState.apiState === "success") {
      notification["success"]({
        message: saveScheduleTimingCustomizeState.message,
        placement: "topRight",
      });
      getScheduleTimingList(props.parameters)
      saveScheduleTimingCustomizeReset();
      dateCellRender(selectedDate);
      props.onClose();
    }
    if (saveScheduleTimingCustomizeState.apiState === "error") {
      notification["error"]({
        message: saveScheduleTimingCustomizeState.message,
        placement: "topRight",
      });
      saveScheduleTimingCustomizeReset();
    }
  }, [saveScheduleTimingCustomizeState]);

  //Function

  

  // const onChangeRange = time => {
  //     setValue(time);
  //     var now = time[0]
  //     var Time = now.format('HH:mm');
  //     Time = Time;
  //     var now1 = time[1]
  //     var Time1 = now1.format('HH:mm');
  //     Time1 = Time1;
  //     setAddSlot({ "start_time": Time, "end_time": Time1 })
  // };

  const onChangeRange = (time, name) => {
    setValue({ ...value, [name]: time });
  };

  const AddSlots = () => {
    setIsModalVisible(true);
  };

  const deleteTimeSlot = (i) => {
    const array = drawerData.time_slots;
    _.remove(array, (data, index) => {
      return index === i;
    });
    if (_.isEmpty(array)) {
      setDrawerData({
        ...drawerData,
        ["time_slots"]: array,
        ["availability"]: true,
      });
      setIsDateAvailable(false);
    } else {
      setDrawerData({ ...drawerData, ["time_slots"]: array });
    }
  };

 
  const handleAddSlot = () => {
    if (value.start_time && value.end_time) {
      let start_time = value.start_time.format("HH:mm");
      let end_time = value.end_time.format("HH:mm");
      if (start_time === end_time) {
        notification["error"]({
          message: "Please choose diffrent time",
          placement: "topRight",
        });
        return true;
      }
      setAddSlot({ start_time: start_time, end_time: end_time });
      setIsModalVisible(false);
      drawerData.time_slots.push({
        start_time: start_time,
        end_time: end_time,
      });
      setDrawerData(drawerData);
      setValue(initialTime);
      // setAddSlot({})
    } else {
      notification["error"]({
        message: "Please choose correct time",
        placement: "topRight",
      });
    }
  };

  const handleConfirmSwitch = () => {
    setIsHolidayModalVisible(false);
    let tempAvailability= !drawerData.availability
      setDrawerData({
      ...drawerData,
      availability: tempAvailability,
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setAddSlot({});
    setValue(initialTime);
  };

  const SendDrawerData = () => {
    saveScheduleTimingCustomize(drawerData);
  };

  const handleCancelSwitch = () => {
    setIsHolidayModalVisible(false);
  };
  return (
    <Drawer
      title={`Manage Slots of ${dateFormat(drawerData.date)}`}
      placement="right"
      closeIcon={
        <XButton
          size="large"
          style={{ position: "absolute", top: "6px", right: "20px" }}
          type="text"
          onClick={props.onClose}
          icon={<CloseOutlined />}
        />
      }
      closable={true}
      visible={props.visible}
      width="400px"
      footer={
        <div
          div
          style={{
            textAlign: "right",
          }}
        >
          <Button className="borderNonPrimary" onClick={props.onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button className="borderPrimary" onClick={SendDrawerData} type="primary">
            Submit
          </Button>
        </div>
      }
    >
      <div>
        <Switch
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          checked={!drawerData.availability}
          onChange={() => {
            setIsHolidayModalVisible(true);
            setConfirmSwitchAction(
              drawerData.availability ? "Mark" : "Unmark"
            );
                      }}
          //   checked =>
          //     setDrawerData({
          //       ...drawerData,
          //       ["availability"]: checked,
          //     })
          // }
          style={{ marginRight: "10px" }}
        />
        <Modal
          title={`${confirmSwitchAction} as Holiday`}
          visible={isHolidayModalVisible}
          onCancel={handleCancelSwitch}
          footer={[
            <Button className="borderNonPrimary" key="cancel" onClick={handleCancelSwitch}>
              Cancel
            </Button>,
            <Button className="borderPrimary" key="confirm" type="primary" onClick={handleConfirmSwitch}>
              Confirm
            </Button>,
          ]}
        >
          <p>
            Are you sure you want to {confirmSwitchAction.toLowerCase()} it as
            holiday?
          </p>
        </Modal>
       
        {drawerData.availability ? (
          <>
            <b>Mark as Holiday</b>
            <br></br>
          </>
        ) : (
          <>
            <b>Marked As Holiday</b>
            <br></br>
          </>
        )}
        <br></br>
        <div style={{ padding: "0%" }}>
          {drawerData.availability ? (
            <>
              <Space style={{ flexFlow: "wrap" }}>
                {drawerData.time_slots.map((item, i) => (
                  <SlotView key={i}>
                    <Space>
                      <div>
                        {timeSlotFormat(item.start_time)} -{" "}
                        {timeSlotFormat(item.end_time)}{" "}
                      </div>
                      {item.is_future_slot && !item.booked && (
                          <Popconfirm
                            title="Are you sure?"
                            onConfirm={() => deleteTimeSlot(i)}
                            okText="Delete"
                            cancelText="Cancel"
                            okType="danger"
                          >
                            <SlotViewDelete>
                              <CloseCircleOutlined />
                            </SlotViewDelete>
                          </Popconfirm>
                        )}
                    </Space>
                  </SlotView>
                ))}
              </Space>
              <SlotViewAdd>
              <div>
                <Button
                  className="d-flex align-items-center"
                  style={{padding:"9px"}}
                  size="large"
                  shape="circle"
                  type="primary"
                  onClick={AddSlots}
                  icon={<PlusOutlined style={{width:"100%",height:"100%"}} />}
                />
              </div>
            </SlotViewAdd>
            </>
            ) : (
            <div>
              <p>You are on a holiday on this date.</p>
            </div>
          )}
        </div>
      </div>
      <Modal
        title="Add Time Slots"
        visible={isModalVisible}
        onCancel={handleCancel}
        width="500px"
        footer={[
          <Button className="borderNonPrimary" key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button className="borderPrimary" key="submit" type="primary" onClick={handleAddSlot}>
            Add Slot
          </Button>,
        ]}
      >
        <div>
          <Space style={{flexWrap:"wrap"}}>
            <TimePicker
              className="scheduleaddTimePicker"
              value={value.start_time}
              onChange={(time) => onChangeRange(time, "start_time")}
              format="h:mm A"
              style={{ width: 140 }}
              placeholder="Start Time"
            />
            <TimePicker
              className="scheduleaddTimePicker"
              value={value.end_time}
              onChange={(time) => onChangeRange(time, "end_time")}
              format="h:mm A"
              style={{ width: 140 }}
              placeholder="End Time"
            />
          </Space>
        </div>
      </Modal>
    </Drawer>
  );
};
const mapStateToProps = (state) => ({
  getScheduleTimingListState: state.getScheduleTimingList,
  saveScheduleTimingCustomizeState: state.saveScheduleTimingCustomize,
});

const mapDispatchToProps = (dispatch) => ({
  getScheduleTimingList: (params) => dispatch(getScheduleTimingList(params)),
  getScheduleTimingListReset: () => dispatch(getScheduleTimingListReset()),
  saveScheduleTimingCustomize: (params) =>
    dispatch(saveScheduleTimingCustomize(params)),
  saveScheduleTimingCustomizeReset: () =>
    dispatch(saveScheduleTimingCustomizeReset()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleTimingCustomize);
